import { createSelector } from 'reselect';

import { AppState } from '../../types';

export const selectVideoMenusList = (state: AppState) => state.videoMenus.list;

export const selectVideoMenu = (state: AppState) => state.videoMenus.selected;

export const isVideoMenuPersistent = createSelector(
  selectVideoMenu,
  (state) => Boolean(state.data?.id),
);

export const selectVideoMenuTitle = createSelector(
  selectVideoMenu,
  (state) => state.data?.title,
);
